import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Clock, CreditCard } from "lucide-react";
import { ReportCustomer } from "./report/ReportCustomer";
import { ReportTransaction } from "./report/ReportTransaction";
import { ReportAllTransactions } from "./report/ReportAllTransactions";

export default function Report() {
  const [activeTab, setActiveTab] = useState<string>("customer");

  const reportTabs = [
    {
      id: "customer",
      name: "Customer Earn/Burn",
      icon: Users,
    },
    {
      id: "transaction",
      name: "Points Expiry",
      icon: Clock,
    },
    {
      id: "all-transactions",
      name: "Transaction Report",
      icon: CreditCard,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Report</h1>
          <p className="text-muted-foreground">
            View and manage various reports
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          {reportTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-sm">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="customer" className="space-y-6">
          <ReportCustomer />
        </TabsContent>

        <TabsContent value="transaction" className="space-y-6 mt-6">
          <ReportTransaction />
        </TabsContent>

        <TabsContent value="all-transactions" className="space-y-6 mt-6">
          <ReportAllTransactions />
        </TabsContent>
      </Tabs>
    </div>
  );
}
